import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { EmpresaCgr } from 'src/app/domain/model/empresa/empresa-cgr';
import { EmpresaCgrRepository } from 'src/app/domain/service/empresa/empresa-cgr-repository';
import { OffsetPageResponse } from 'src/app/domain/model/common/offset-page-response.dto';

const BASE_URL = `${environment.backend.baseUrl}/servicios/empresas/buscar`;

@Injectable()
export class HttpEmpresaCgrRepository implements EmpresaCgrRepository {

  private readonly http = inject(HttpClient);

  async buscar(
    dni: string | null | undefined,
    nombre: string | null | undefined,
    pageNumber: number,
    pageSize: number
  ): Promise<OffsetPageResponse<EmpresaCgr>> {
    let params = new HttpParams()
      .set('pageNumber', pageNumber.toString())
      .set('pageSize', pageSize.toString());

    if (dni?.trim()) params = params.set('dni', dni.trim());
    if (nombre?.trim()) params = params.set('nombre', nombre.trim());

    return firstValueFrom(
      this.http.get<OffsetPageResponse<EmpresaCgr>>(BASE_URL, { params })
    );
  }
}
